<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M73.3327 36.9342V40.0008C73.3286 47.1889 71.001 54.1831 66.6971 59.9403C62.3932 65.6974 56.3436 69.9091 49.4505 71.9472C42.5575 73.9853 35.1902 73.7405 28.4476 71.2495C21.705 68.7584 15.9482 64.1545 12.0359 58.1244C8.12357 52.0943 6.26532 44.9611 6.73827 37.7886C7.21122 30.6161 9.99004 23.7886 14.6603 18.3244C19.3305 12.8602 25.642 9.05212 32.6533 7.468C39.6647 5.88388 47.0002 6.60864 53.566 9.53418"
    stroke="#47C693"
    stroke-width="6.15"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M73.3333 13.333L40 46.6997L30 36.6997"
    stroke="#47C693"
    stroke-width="6.15"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>

<h2>That's it! Thanks for taking your time.</h2>

<p>We successfully connected your account. You can now safely close this window. Thank you!</p>
